import { ReactNode } from 'react'
import Modal from 'react-modal'
import { BigButton } from '../buttons/bigButton'
import { useTranslator } from '../translator/hook'
import '../../styles/modal.css'

export type SimpleModalProps = {
  isOpen: boolean
  imgUrl?: string
  imgW?: number
  modalTitle?: string
  modalDetail?: ReactNode
  buttonLabel?: string
  closeButtonLabel?: string
  onClick?: () => void
  onClose: () => void
}

export const SimpleModal: React.FC<SimpleModalProps> = ({
  isOpen,
  imgUrl,
  imgW,
  modalTitle,
  modalDetail,
  buttonLabel,
  closeButtonLabel,
  onClick,
  onClose,
}: SimpleModalProps) => {
  Modal.setAppElement('#root')
  const { t } = useTranslator()

  return (
    <Modal
      className="modal-content"
      isOpen={isOpen}
      contentLabel="Example Modal"
      onRequestClose={onClose}
      style={{
        overlay: {
          alignItems: 'center',
          display: 'flex',
          justifyContent: 'center',
          zIndex: 861,
        },
      }}
    >
      {imgUrl && (
        <img src={imgUrl} style={{ maxWidth: `${imgW}px`, width: '100%' }} />
      )}
      {modalTitle && <h1 className="modal-title">{modalTitle}</h1>}
      {modalDetail && <div className="modal-detail">{modalDetail}</div>}
      <div>
        {onClick && buttonLabel && (
          <BigButton className="modal-action-big-button" onClick={onClick}>
            {buttonLabel}
          </BigButton>
        )}
        <BigButton onClick={onClose}>
          {closeButtonLabel ?? t('button_back')}
        </BigButton>
      </div>
    </Modal>
  )
}
